export default __webpack_public_path__ + "static/media/bin.50d5226b.svg";